export const WidgetActions = {
    WIDGET_CLICK: "widget/widget-click",
};

export default WidgetActions;



// WEBPACK FOOTER //
// ./app/data/WidgetActions.js